import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "home-images" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]

import AppActivity from "@/components/AppActivity.vue";

import {ICON_ARBEITSPLAN_KUPIERVERZICHT, ICON_BANNER, ICON_EU_BANNER, ICON_VOES_LOGO_ORIGINAL} from "@/lib/icons";
import {useRouter} from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeActivity',
  setup(__props) {

const router = useRouter()

const onClick = () => {
  router.push({ name: 'menu' })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AppActivity, {
    title: "Risiko - Analyse",
    onClick: onClick
  }, {
    default: _withCtx(() => [
      _createElementVNode("ul", _hoisted_1, [
        _createElementVNode("li", null, [
          _createElementVNode("img", { src: _unref(ICON_ARBEITSPLAN_KUPIERVERZICHT) }, null, 8, _hoisted_2)
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("img", { src: _unref(ICON_BANNER) }, null, 8, _hoisted_3)
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("img", { src: _unref(ICON_VOES_LOGO_ORIGINAL) }, null, 8, _hoisted_4)
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("img", { src: _unref(ICON_EU_BANNER) }, null, 8, _hoisted_5)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})